import * as Yup from "yup";
import { useTranslation } from "react-i18next";
export const useValidationForSendMailResetPassword = () => {
    const { t } = useTranslation("resetPassword");
    const validationSchema = Yup.object().shape({
        email: Yup.string().trim().email(t("enterEmail.formVlidation.email.invalid")).required(t("enterEmail.formVlidation.email.required")),
    });
    return {validationSchema}
}
